<div class="cleanup-modal">
  <h2 class="cleanup-title">Game Cleanup</h2>
  <p class="cleanup-info">
    {{ upgradePlan?.name | uppercase }} subscription allows for
    <strong>
      @if (upgradePlan?.features?.max_games_created === -1) {
        Unlimited
      } @else {
        {{ upgradePlan?.features?.max_games_created }}
      }
    </strong>
    games. Items in <span class="cleanup-danger-word">red</span> will be deleted.
  </p>

  @if (gameList.length > 0) {
    <div class="cleanup-table-wrap">
      <table class="cleanup-table">
        <thead>
          <tr>
            <th>Game Name</th>
            <th>Map</th>
            <th># Players</th>
            <th>Last Played</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (g of gameList; track g) {
            <tr>
              <td [class.cleanup-danger]="isGameAutoDeleted(g)">{{ g.Gamename | uppercase }}</td>
              <td [class.cleanup-danger]="isGameAutoDeleted(g)">{{ g.map_name }}</td>
              <td [class.cleanup-danger]="isGameAutoDeleted(g)">{{ g.active_characters?.length || 0 }}</td>
              <td [class.cleanup-danger]="isGameAutoDeleted(g)">{{ (g.LastPlayed | date:'MMM d, yyyy') || 'Never' }}</td>
              <td>
                @if (!isGameAutoDeleted(g)) {
                  <div class="cleanup-row-actions">
                    <button type="button" class="cleanup-icon-btn" title="Delete Game" (click)="deleteSingleGame(g.id)" [disabled]="isLoading">
                      <img src="assets/icons/icon-delete.svg" alt="Delete">
                    </button>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (manualGamesToDelete > 0) {
    <p class="cleanup-summary cleanup-summary--danger">
      Please delete <span class="cleanup-summary-count">{{ manualGamesToDelete }}</span> game(s)
    </p>
  }
  @if (manualGamesToDelete === 0) {
    <p class="cleanup-summary cleanup-summary--success">No games require deletion</p>
  }

  <div class="cleanup-actions">
    @if (!downgradeResponse?.cleanup_required) {
      <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
    }
    <button type="button" class="btn btn-theme" (click)="next()" [disabled]="manualGamesToDelete > 0 || isLoading">Proceed</button>
    <button type="button" class="btn btn-theme" (click)="subscribe()">Subscribe</button>
  </div>
</div>
